import React from 'react';

export function EmptyState({ icon = 'ti-inbox', title, desc, action }) {
  return (
    <div className="empty">
      <i className={`ti ${icon}`} />
      <div className="empty-title">{title}</div>
      <div className="xs">{desc}</div>
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}